import { render, staticRenderFns } from "./BotaoWhatsappDesktop.vue?vue&type=template&id=5a17bf4e"
import script from "./BotaoWhatsappDesktop.vue?vue&type=script&lang=js"
export * from "./BotaoWhatsappDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cleverton/paytour-payt-1702/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a17bf4e')) {
      api.createRecord('5a17bf4e', component.options)
    } else {
      api.reload('5a17bf4e', component.options)
    }
    module.hot.accept("./BotaoWhatsappDesktop.vue?vue&type=template&id=5a17bf4e", function () {
      api.rerender('5a17bf4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/apps/botao-whatsapp/components/BotaoWhatsappDesktop.vue"
export default component.exports